import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware, LOCATION_CHANGE } from 'connected-react-router';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import createHistory from 'history/createBrowserHistory';
import createRootReducer from '../reducers/index';
import { removeSSRByHook } from '../utils/ssrCleanup';

const inDevMode = false;
export const history = createHistory();

const normalizePath = path => {
  const p = (path || '/').replace(/\/+$/, '');
  return p === '' ? '/' : p;
};

const isServicePath = path => normalizePath(path).startsWith('/tjanster');

let lastPath = normalizePath(history.location.pathname);
/**
 * Cleans up SSR-rendered elements when navigating between routes.
 *
 * Some SSR elements are rendered through a Portal in the dom, and React does not automatically clean them up when the route changes.
 * This function ensures that those elements are removed to prevent stale or conflicting content.
 */
const ssrCleanupMiddleware = store => next => action => {
  if (action.type !== LOCATION_CHANGE) return next(action);
  var payload = action.payload || {};
  var location = payload.location || {};
  var isFirstRendering = payload.isFirstRendering === true;

  var nextPath = normalizePath(location.pathname);
  var prevPath = lastPath;
  var result = next(action);

  if (!isFirstRendering && prevPath !== nextPath) {
    if (isServicePath(prevPath) && !isServicePath(nextPath)) {
      removeSSRByHook('service-subhero');
    }
    removeSSRByHook('breadcrumbs');
  }

  lastPath = nextPath;
  return result;
};

const initialState = {};
const enhancers = [];

const middleware = inDevMode
  ? [thunk, routerMiddleware(history), ssrCleanupMiddleware, logger]
  : [thunk, routerMiddleware(history), ssrCleanupMiddleware];

if (inDevMode) {
  const devToolsExtension = window.devToolsExtension;
  if (typeof devToolsExtension === 'function') enhancers.push(devToolsExtension());
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);
const store = createStore(createRootReducer(history), initialState, composedEnhancers);

export default store;
